export default __webpack_public_path__ + "static/media/workflow.3381e6a2.png";